<template>
	<div>
		<div class="TopSearch">
			<FromComm :FromArr="FromArr"></FromComm>
			<div class="btngroup">
				<CommonBtngroup ref="btngroup" :qhide="false" @select="handSearch" @reset="handReset"></CommonBtngroup>
			</div>
		</div>
		<div class="BottomTable">
			<!-- v-if="qx.add" -->
			<Commonbtn v-if="auth.includes('add')" backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="add"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<!--  v-if="qx.update" -->
			<Commonbtn v-if="auth.includes('edit')" backgroundColor="#FFF" title="修改" fontSize="14px" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<!--  v-if="qx.del" -->
			<Commonbtn v-if="auth.includes('delete')" backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<!--v-if="qx.enabled"-->
			<CommonbtnUpLoad v-if="auth.includes('add')" types="files" backgroundColor="#FFF" title="年度指标导入" fontSize="14px"
				@getFiles="SealUpload" :src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<CommonbtnUpLoad v-if="auth.includes('add')" types="files" backgroundColor="#FFF" title="月度指标导入"
				fontSize="14px" @getFiles="SealMonthUpload" :src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<!-- <div style="margin-left: 10px;display: inline-block;">
				<a class="Dowload" style="text-decoration: underline;" @click="DownloadTemplate">下载模版</a>
			</div> -->
			<div style="margin-left: 10px;display: inline-block;">
				<a class="Dowload" v-for="(item,index) in downlist" :key="index" style="text-decoration: underline;"
					@click="openTemplate(item.Value)">下载{{item.Text.replace(/医院IMS指标/g,'')}}</a>
			</div>
		</div>
		<div class="Table">
			<Commontable ref="refTableCenter" @onRowClick="onRowClick" width="1000px" colnum=7 :tableData="tableData"
				:headerData="headerData" height="100%" @handleSelectionChange="handleSelectionChange">
			</Commontable>
			<div class="pagination">
				<Pagination ref="invPagination" type='allColor' :pageSize="query.pageSize"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
				</Pagination>
			</div>
		</div>
		<DialogFrom width="1060px" :title="tableCurr?'修改':'新增'" :OKASCAN="true" :dialogVisible="dialogShow"
			@cancel="cancelEditor" @dialogOK="dialogOKEditor">
			<FromComm :FromArr="FromArrEditor" @remoteMethod="remoteMethod"
				@AuthorizedDealerChange="AuthorizedDealerChange"></FromComm>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleDel" @cancel="dialogVisibleDel = false"
			@dialogOK="dialogOKDel" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条信息吗？</span>
		</Dialog>

		<DialogFrom width="890px" title="导入结果" :dialogVisible="dialogVisiblesdrjg" @cancel="dialogVisiblesdrjg = false"
			@dialogOK="dialogVisiblesdrjg = false">
			<div class="from" style="">
				<Commontable width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
	</div>
</template>

<script>
	import FromComm from '../../../../components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../../../../components/commongroup.vue'
	import Commonbtn from '../../../../../../../components/common-btn.vue'
	import DialogFrom from '../../../../../../../components/dialog-from.vue'
	import Pagination from '../../../../../../../components/pagination.vue'
	import CommonbtnUpLoad from './../../../../../../../components/common-upload.vue'
	import Commontable from '../../../../../../../components/common-table.vue'
	import Dialog from '../../../../../../../components/dialog.vue'
	import FromArr from '../FormData/FromArrIms'
	import FromArrEditor from '../FormData/FromArrEditorIms'
	import headerData from '../TableData/headerData'
	import {
		InventoryClassList,
		HospitalList,
		HelperTechnicalOfficesList
	} from '@/api/home'
	import {
		HelperLEVEL3
	} from '@/api/channel'
	import {
		GetQuotaIMSYearList,
		GetQuotaIMSYearInfo,
		DownloadQuotaIMSYear,
		ImportQuotaIMSYearInfo,
		AddQuotaIMSYear,
		EditQuotaIMSYear,
		DeleteQuotaIMSYear,
		ImportQuotaIMSYear
	} from '@/api/newsapi'
	export default {
		props: {
			auth: Array
		},
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			DialogFrom,
			Dialog,
			Pagination,
			CommonbtnUpLoad,
			Commontable
		},
		data() {
			return {
				total: 0,
				query: {
					pageIndex: 1,
					pageSize: 10
				},
				dialogShow: false,
				FromArr: [],
				FromArrEditor: [],
				tableCurr: null,
				tableData: [],
				headerData: [],
				dialogVisibleDel: false, //删除弹窗
				tableDatadrjg: [],
				dialogVisiblesdrjg: false,
				selectIds: [],
				downlist: []
			}
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArrEditor = JSON.parse(JSON.stringify(FromArrEditor))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.inventoryClassList();
			this.HelperLEVEL3();
			this.getData();
			this.DownloadTemplate();
		},
		methods: {
			handleSelectionChange(e) {
				this.selectIds = e.map(item => item.ID);
			},
			async getData() {
				this.query.year = this.FromArr[0].modelvalue;
				this.query.invClass = this.FromArr[1].modelvalue;
				this.query.leveL3 = this.FromArr[2].modelvalue;
				this.query.hospital = this.FromArr[3].modelvalue;

				let {
					code,
					data
				} = await GetQuotaIMSYearList(this.query)
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.FromArr[0].options = []
					this.FromArr[1].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.FromArr[1].options.push(obj)
						this.FromArrEditor[1].options.push(obj)
					})
					let date = new Date()
					let yearArr = [
						date.getFullYear() - 1,
						date.getFullYear(),
						date.getFullYear() + 1
					]
					yearArr.map((item, index) => {
						let obj = {
							key: item,
							value: item
						}
						this.FromArr[0].options.push(obj)
						this.FromArrEditor[0].options.push(obj)
					})
				} else {
					this.$message.error('公司加载失败')
				}
			},
			// 产品分类L3
			async HelperLEVEL3() {
				let {
					code,
					data,
					message
				} = await HelperLEVEL3({})
				if (code == 0) {
					this.FromArr[2].options = []
					this.FromArrEditor[2].options = []
					data.forEach((item, index) => {
						let obj = {
							key: item.key,
							value: item.value
						}
						this.FromArr[2].options.push(obj)
						this.FromArrEditor[2].options.push(obj)
					})
				}
			},
			handSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			handReset() {
				this.query = {
					pageIndex: 1,
					pageSize: 10
				};
				this.FromArr.map((item, index) => {
					item.modelvalue = '';
				})
				this.getData();
			},
			add() {
				this.dialogShow = true;
			},
			// 指标删除
			del() {
				if (!this.selectIds.length) {
					this.$message.warning('请选择您要操作的数据')
					return
				}
				this.dialogVisibleDel = true
			},
			async dialogOKDel() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				this.dialogVisibleDel = false;
				let {
					code,
					data
				} = await DeleteQuotaIMSYear({
					ids: this.selectIds
				})
				if (code == 0) {
					this.selectIds = [];
					this.$message('已删除');
					this.handSearch();
					this.$refs.refTableCenter.$refs.multipleTable.clearSelection();
				} else if (code == 1) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data;
				} else {
					this.$message.error(message);
				}
				loading.close();
			},
			onRowClick(val) {
				this.tableCurr = val.ID;
			},
			// 批量导入
			async SealUpload(file) {
				if (file && file.length) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file[0])
					let res = await ImportQuotaIMSYearInfo(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})
						this.handSearch();
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
					}
					loading.close();
				}
			},
			//编辑
			async update() {
				if (!this.tableCurr) {
					this.$message.error('请先选择数据');
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data
				} = await GetQuotaIMSYearInfo({
					id: this.tableCurr
				})
				if (code == 0) {
					this.FromArrEditor = this.FromArrEditor.map((item, index) => {
						item.modelValue = data.data[item.key];
						item.modelvalue = data.data[item.key];
						if (index === 3) {
							item.options = [{
								label: data.data.HPName,
								value: data.data.HPID
							}]
						}
						return item;
					})
					await this.loadTechnicalOfficesOptions(data.data.HPID)
					if (this.FromArrEditor[4]) {
						if (data.data.TechnicalOfficesID && data.data.TechnicalOfficesName && !this.FromArrEditor[4].options.some(
								item => item.key == data.data.TechnicalOfficesID)) {
							this.FromArrEditor[4].options.push({
								key: data.data.TechnicalOfficesID,
								value: data.data.TechnicalOfficesName
							})
						}
						this.FromArrEditor[4].modelvalue = data.data.TechnicalOfficesID || ''
					}
					this.dialogShow = true;
					this.$forceUpdate();
				}
				loading.close();
			},
			//模糊查询
			async remoteMethod(val) {
				let {
					code,
					data
				} = await HospitalList({
					HosType: "医院",
					hpName: val.qurey,
					pageIndex: 1,
					pageSize: 9999
				})
				if (code == 0) {
					this.FromArrEditor[3].options = []
					data.data.forEach((item, index) => {
						let obj = {
							label: item.HPName,
							value: item.HPID
						}
						this.FromArrEditor[3].options.push(obj)
					})
				}
			},
			async loadTechnicalOfficesOptions(hospitalId) {
				if (this.FromArrEditor[4]) {
					this.FromArrEditor[4].options = [];
				}
				if (!hospitalId) {
					return;
				}
				let {
					code,
					data
				} = await HelperTechnicalOfficesList({
					Hospital: Number(hospitalId)
				})
				if (code == 0 && this.FromArrEditor[4]) {
					this.FromArrEditor[4].options = (Array.isArray(data) ? data : []).map(item => {
						return {
							key: item.Value,
							value: item.Text
						}
					})
				}
			},
			async AuthorizedDealerChange() {
				if (this.FromArrEditor[4]) {
					this.FromArrEditor[4].modelvalue = '';
				}
				await this.loadTechnicalOfficesOptions(this.FromArrEditor[3].modelvalue);
			},
			// 下载模板
			async DownloadTemplate() {
				let {
					code,
					data
				} = await DownloadQuotaIMSYear({})
				if (code == 0) {
					this.downlist = data; //.filter(it => it.Text.includes('月度'));
				}
			},
			openTemplate(url) {
				window.open(url);
			},
			//取消编辑
			cancelEditor() {
				this.FromArrEditor = this.FromArrEditor.map(item => {
					item.modelValue = undefined;
					item.modelvalue = '';
					return item;
				})
				this.tableCurr = null;
				this.dialogShow = false;
				this.$forceUpdate();
			},
			async dialogOKEditor() {
				let params = {};
				this.FromArrEditor.map(item => {
					params[item.key] = item.modelValue || item.modelvalue
				})
				if (this.tableCurr) {
					params.id = this.tableCurr;
					let {
						code,
						data,
						message
					} = await EditQuotaIMSYear(params)
					if (code == 0) {
						this.tableCurr = null;
						this.$message('已修改');
						this.cancelEditor();
						this.handSearch();
					} else {
						this.$message.error(message);
					}
				} else {
					let {
						code,
						data,
						message
					} = await AddQuotaIMSYear(params)
					if (code == 0) {
						this.$message('已添加');
						this.cancelEditor();
						this.handSearch();
					} else {
						this.$message.error(message);
					}
				}
			},
			handleCurrentChange(e) {
				this.query.pageIndex = e
				this.getData()
			},
			handleSizeChange(e) {
				this.query.pageSize = e
				this.getData()
			},
			// 批量导入
			async SealMonthUpload(file) {
				if (file && file.length) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file[0])
					let res = await ImportQuotaIMSYear(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})
						this.handSearch();
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
					}
					loading.close();
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.TopSearch {
		height: 140px;
		margin: 16px 0px 8px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

		.btngroup {
			// border: 1px solid #0b65ec;
			position: relative;
			bottom: 20px;
		}
	}

	.BottomTable {
		margin-bottom: 14px;
	}

	.custom-table {
		cursor: pointer;
		user-select: none;
		margin-bottom: 16px;
		box-sizing: border-box;

		.table-header {
			height: 40px;
			background: #00266D;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0px 16px;

			span {
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
				font-weight: 400;
				color: #FFFFFF;
			}
		}

		.red {
			background: #E71D43;
		}

		.table-title {
			display: flex;

			.title-item {
				flex: 1;
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
				font-weight: 500;
				color: #333333;
				height: 40px;
				line-height: 40px;
				text-align: center;
				border-bottom: 1px solid #EEEEEE;
				border-right: 1px solid #EEEEEE;
				box-sizing: border-box;
			}

			.title-item:last-child {
				border-right: 0px;
			}
		}

		.table-value {
			display: flex;

			.value-item {
				flex: 1;
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
				font-weight: 500;
				color: #333333;
				height: 40px;
				line-height: 40px;
				text-align: center;
				border-bottom: 1px solid #EEEEEE;
				border-right: 1px solid #EEEEEE;
				box-sizing: border-box;
			}

			.value-item:last-child {
				border-right: 0px;
			}
		}
	}

	.select-table {
		border: 1px solid #00266D;
	}
</style>
